<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      title="导航"
      id="topbar"
      style="background-color: #4263EB"
      left-arrow
      @click-left="$router.push({name: pushName})"
    >
    </van-nav-bar>


    <iframe :src="hrefUrl" :style="{'height': clientHeight-60+'px','width': '100%'}" style="position: fixed" v-if="hrefUrl!==''"></iframe>





  </div>
</template>

<script>
export default {
  name: "index",
  data(){
    return {
      clientHeight: window.screen.height,
      clientWidth: window.screen.width,
      pushName: '',
      hrefUrl: '',
    }
  },
  mounted() {
    AMap.plugin("AMap.Geolocation", () => {
      var geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        // 设置定位超时时间，默认：无穷大
        timeout: 10000,
      });

      geolocation.getCityInfo((status, result) => {   //只能获取当前用户所在城市和城市的经纬度
        if (status == "complete") {
          console.log("result",result)

        }
      })
      geolocation.getCurrentPosition((status, result) => {  //获取用户当前的精确位置
        if (status == "complete") {
          console.log("result",result)

        }
      })
    })
    console.log('item',this.$route.params.item)
    console.log('pushName',this.$route.params.pushName)

    this.pushName = this.$route.params.pushName


    const item  = this.$route.params.item
    // alert("不在小程序")
    this.hrefUrl = `https://uri.amap.com/marker?position=${item.longitude},${item.latitude}&name=${item.pointAddress}`;



  }
}
</script>

<style scoped>

</style>
